import Click from '../../../plugins/input/button/Button.js'
export default Click;